import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-price-drop-strategy';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Poshmark Price Drop Strategy - A Seller’s Guide to More Sales</title>
        <meta
          name='description'
          content='Turn stale listings into sold items using the Poshmark price drop tool – here’s how!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-price-drop-strategy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-price-drop-strategy' />
        <meta property='og:title' content='The Poshmark Price Drop Strategy - A Seller’s Guide to More Sales' />
        <meta
          property='og:description'
          content='Turn stale listings into sold items using the Poshmark price drop tool – here’s how!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-08-10T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-08-10T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
